export const TwoE16 = 2 ** 16
export const keys = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 'A100', 'A200', 'A400', 'A700']
export const defaultOptions = {
  threshold: 128,
  showContrastText: false
}
